
import GlobalSearch from "../../../assets/outline/GlobalSearch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GlobalSearchIcon({ className, dataTestid = "GlobalSearchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GlobalSearch data-testid={dataTestid} className={classes} {...rest} />
  );
}
